
export const ZOOM_EM_STEPS = 0.5;
export const START_ZOOM = 2;